const LOCALE_FORMAT_WITH_COMMAS = 'en-US';

export const formatPriceWithCurrency = (
  value: string | number | undefined,
  currency: string,
  period?: string,
): string | undefined => {
  if (!value && typeof value !== 'number') return undefined;

  const stringifiedValue = `${value}`;
  const numericValue = Number(stringifiedValue.replace(/\s/g, ''));

  if (!numericValue) return value as string;

  const roundedValue = numericValue.toFixed(2);
  const formattedValue = Number(roundedValue)
    .toLocaleString(LOCALE_FORMAT_WITH_COMMAS)
    .replace(/,/g, ' ');

  const price = `${formattedValue} ${currency}`;
  const pricePerPeriod = `${formattedValue} ${currency} / ${period}`;

  return period ? pricePerPeriod : price;
};
